import { styled, Box, Typography, Skeleton } from "@mui/material";

const TabsParentContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#e5e5e5",
  padding: theme.spacing(2),
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const TitleContainer = styled(Typography)(({ theme }) => ({
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  WebkitLineClamp: 3,
  textAlign: "center", // Center the text within the Typography
  padding: theme.spacing(0, 1),
}));

const BoxContainer = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(1.25),
  width: theme.spacing(16),
  height: theme.spacing(15),
  margin: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  cursor: "pointer",
  outline: "3px solid",
  outlineColor: "inherit",
  outlineOffset: "2px",
}));

const BoxSkeleton = styled(Skeleton)(({ theme }) => ({
  borderRadius: theme.spacing(1.25),
  width: theme.spacing(16),
  height: theme.spacing(15),
  margin: theme.spacing(2),
}));

const TableTabContaier = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.white,
}));

export {
  BoxContainer,
  TabsParentContainer,
  TitleContainer,
  TableTabContaier,
  BoxSkeleton,
};
